// Status
export const NOTIFICATION = 'NOTIFICATION';

// UI
export const OPEN_TOAST_MESSAGE = 'SHOW_TOAST_MESSAGE';
export const CLOSE_TOAST_MESSAGE = 'CLOSE_TOAST_MESSAGE';
